/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {

  fetchReceipts({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/receipts")
        .then((response) => {
          commit('SET_RECEIPTS', response.data)
          commit('SET_RECEIPTS_COUNT', response.data.length)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  searchReceipts({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/searchreceipts", data)
        .then((response) => {
          commit('SET_RECEIPTS', response.data)
          commit('SET_RECEIPTS_COUNT', response.data.length)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
}
